import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Text } from '@reservamos/elements';
import dotersLogo from 'images/doters/greendoters.svg';

/**
 * LoyaltyPassengerCard component.
 * Render a card displaying loyalty passenger information with name, email, and custom content.
 * @param {object} props - name, email, children.
 * @param {string} props.name - The passenger's name.
 * @param {string} props.email - The passenger's email address.
 * @param {React.ReactNode} props.children - Custom content to display in the card body.
 */
const LoyaltyPassengerCard = ({ name, email, children }) => {
  return (
    <div className="rounded-xl border shadow-md">
      <div className="bg-loyalty-session relative px-2 pt-4 pb-2 rounded-t-xl  flex justify-center items-center flex-col">
        <div className="absolute rounded-full flex shadow-lg -top-4">
          <Icon type={dotersLogo} aria-hidden="true" />
        </div>
        {name && (
          <Text color="white" weight="bold">
            {name}
          </Text>
        )}
        {email && (
          <Text color="white" size="S">
            {email}
          </Text>
        )}
      </div>
      <div className="bg-white px-2 py-2 space-y-4 rounded-b-xl">{children}</div>
    </div>
  );
};

LoyaltyPassengerCard.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
  children: PropTypes.node,
};

LoyaltyPassengerCard.defaultProps = {
  name: '',
  email: '',
  children: null,
};

export default LoyaltyPassengerCard;
